import _ from 'underscore';

/*

loggedInNavCtrl.js

Angular controller that displays all content in the navbar

*/

angular.module('am4').controller('loggedInNavCtrl',
    function($scope,
             $rootScope,
             $state,
             $timeout,
             $interval,
             $window,
             $q,
             UserService,
             filterService,
             errorService,
             orgFacService) {

        // variable to initialize index
        var i = 0,

        // variable to hold window object
            window = angular.element($window),
            tokenExpiry = UserService.token.decoded.exp,
            timeToTokenExpiry = (tokenExpiry * 1000) - Date.now(), // milliseconds
            email;

        // function to log the user out of AM4
        $scope.logout = function() {
            UserService.logout()
            .then(function() {
                // redirect to login
                $state.go('app.login');
            });
        };

        if (timeToTokenExpiry > 0) {
            UserService.user.then(function(user) {
                // run this in parallel - it's OK if this doesn't resolve
                // before the timeout runs, the email field will just not
                // be prefilled when logging in
                email = user.email;
            });

            // log the user out when their token expires
            // why $interval and not $timeout?
            // https://github.com/angular/protractor/issues/169
            let intervalCanceller = $interval(function() {
                sessionExpired();

                $interval.cancel(intervalCanceller);
            }, timeToTokenExpiry);
        } else {
            sessionExpired();
        }

        function sessionExpired() {
            return UserService.logout()
            .then(function() {
                // redirect to login
                $state.go('app.expired', {
                    email: email
                });
            });
        }

        // intialize tabs array of object
        $scope.tabs = [
            { heading: 'DASHBOARD', route: 'app.am4.dashboard.results', active: false, index: i++ }
        ];

        // function to update the filters visible in the tab bar
        $scope.updateFilters = function() {
            filterService.getFilters()
            .then(function(res) {
                // get filters and then remove all old ones except the static dashboard object
                $scope.tabs = $scope.tabs.slice(0, 1);
                $scope.dropdown = [];
                return _.map(res, function(filter) {
                    // reset index count to 1
                    i = 1;
                    return {
                        heading: filter.name,
                        route: 'app.am4.dashboard.results',
                        param: { filterId: filter.filter_uuid },
                        active: false,
                        index: i++
                    };
                });
            })
            .then(measureWidth)
            .catch(function(e) {
                errorService.addError('GET_FILTER_ERROR', e);
            });
        };

        $scope.deleteFilter = function(id, tab, e) {
            e.stopPropagation();
            e.preventDefault();

            tab.deleting = true;
            // delete filter
            filterService.deleteFilterById(id)
            .then(function() {
                // if you were looking at the filter you just deleted, redirect
                if ($state.params && $state.params.filterId === id) {
                    $state.go('app.am4.dashboard.results', {
                        filterId: null
                    });
                }
                // slice tab from the tab array. It appears that DynamoDB does not update
                // fast enough to return the correct data this soon after deletion, so we fake
                // it by slicing it on the front end
                sliceTab(id);
            })
            .catch(function(e) {
                errorService.addError('DELETE_FILTER_ERROR', e);
            });
        };

        $scope.getUserObject = function() {
            UserService.user
            .then(function(res) {
                $rootScope.isAdmin = res.user_metadata.am_roles.indexOf('ADMINISTRATOR') !== -1;
                $rootScope.adminOrganizations = res.user_metadata.admin_organizations;
                $scope.isAdmin = $rootScope.isAdmin;
                $scope.displayName = res.nickname || res.name;
                $scope.userOrgs = res.user_metadata.am_organizations;
                $scope.userFacs = res.user_metadata.am_facilities;
            })
            .then(function() {
                return $q.all([orgFacService.getOrganizationsDictionary(), orgFacService.getFacilitiesDictionary()]);
            })
            .then(function(responses) {
                $scope.orgLookup = responses[0];
                $scope.facLookup = responses[1];
            })
            .catch(function(e) {
                errorService.addError('GET_USER_INFO_ERROR', e);
            });
        };

        // initial behavior, set the filters properly
        $scope.updateFilters();
        $scope.getUserObject();

        // if an updateTabs signal is sent from dashboardCtrl, this handles and updates
        $scope.$on('updateTabs', function() {
            $scope.updateFilters();
        });

        $scope.errors = errorService.currentErrors();

        $scope.$on('updateErrors', function() {
            $scope.errors = errorService.currentErrors();
        });

        $scope.deleteError = function(err) {
            errorService.deleteError(err);
        };

        // binding of a resize event to a function. Function is debounced because many many resize
        // events are emitted for what a user would consider a resize
        window.bind('resize', _.debounce(function() {
            // save all non static tabs to a variable
            var allTabs = $scope.tabs.slice(1, $scope.tabs.length);
            if (!_.isUndefined($scope.dropdown) && $scope.dropdown.length > 0) {
                allTabs = allTabs.concat($scope.dropdown);
            }
            // cut all dynamic tabs
            $scope.tabs = $scope.tabs.slice(0, 1);
            $scope.dropdown = [];
            // resize accordingly
            $timeout(function() {
                measureWidth(allTabs);
            });
        }, 500));

        // function to slice tabs out when deleted
        function sliceTab(id) {
            // variables for iteration
            var i = 0,
                j = 0,
                // Copy tabs array without 'Dashboard' tab
                allTabs = $scope.tabs.slice(1);

            // iterate to find tab to be sliced or end of list
            while (i < allTabs.length && allTabs[i].param.filterId !== id) { i++; }
            // if we found the tab in allTabs, delete it
            if (i < allTabs.length) {
                allTabs.splice(i, 1);
            } else {
                // otherwise search through dropdown and delete it
                while ($scope.dropdown[j].param.filterId !== id) { j++; }
                $scope.dropdown.splice(j, 1);
            }

            if (!_.isUndefined($scope.dropdown) && $scope.dropdown.length > 0) {
                allTabs = allTabs.concat($scope.dropdown);
            }
            $scope.tabs = $scope.tabs.slice(0, 1);
            $scope.dropdown = [];
            // resize according to the new set of tabs
            measureWidth(allTabs);
        }

        function measureWidth(results) {
            // timeout to allow tab to render
            $timeout(function() {
                // threshold after which filters should be put in dropdown
                var widthCutoff = $('.am4-tabs').width(), // eslint-disable-line no-undef
                    total = 20; // safety margin

                // add width of all elements with navTab as a class
                $('.am4-tabs__tab').each(function(index) { // eslint-disable-line no-undef
                    var tabWidth = $(this).outerWidth(true); // eslint-disable-line no-undef
                    $scope.tabs[index].width = tabWidth; // store the width in with the model
                    total += tabWidth; // eslint-disable-line no-undef
                });

                // if total is less than widthCutoff, iterate again
                if (total < widthCutoff) {
                    // push next tab onto the stack
                    if (results.length) {
                        $scope.tabs.push(results.shift());
                        measureWidth(results);
                    } // else this means all our tabs fit
                } else {
                    // otherwise save filters that belong in dropdown
                    total -= $scope.tabs[$scope.tabs.length-1].width;
                    results.unshift($scope.tabs.pop());
                    $scope.dropdown = results;

                    // Ensure the 'More' tab fits
                    $timeout(function() {
                        var moreTabWidth = $('.am4-tabs__tab--more-items').first().outerWidth(true); // eslint-disable-line no-undef

                        if (total + moreTabWidth > widthCutoff) {
                            // Hide tabs one by one until there is enough room for the 'More' tab to fit
                            for (let i = $scope.tabs.length - 1; i > 0; i--) {
                                total -= $scope.tabs[i].width; // we stored this value when we looped through .am4-tabs__tab
                                $scope.dropdown.unshift($scope.tabs.pop());
                                if (total + moreTabWidth <= widthCutoff) {
                                    i = 0;
                                }
                            }
                        }
                    });
                }
            });
        }
    });



// WEBPACK FOOTER //
// ./src/app/controllers/loggedInNavCtrl.js